import { track } from "jiffy-analytics";
import EventClass from "common/utils/ui/event-class";
import DesignUploadCtaPlpPreviewClass from "./design-upload-cta-plp-preview-class";
import DesignUploadCtaPlpErrorClass from "./design-upload-cta-plp-error-class";
import DesignUploadCtaPlpCookieClass from "./design-upload-cta-plp-cookie-class";

export default class DesignUploadCtaPlpFileRemoveClass extends EventClass {
  static async #removeFile() {
    try {
      DesignUploadCtaPlpCookieClass.cookie = null;
      await DesignUploadCtaPlpPreviewClass.hide();
    } catch (error) {
      new DesignUploadCtaPlpErrorClass(
        error.response?.data?.error || "Remove failed. Please try again."
      ).showError();
    }
  }

  async event(event, $target) {
    super.event(event, $target);

    $target.setAttribute("disabled", "disabled");
    await DesignUploadCtaPlpFileRemoveClass.#removeFile();
    $target.removeAttribute("disabled");
    track("pdp_design_preview_remove_clicked");
  }
}
